import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled, { css } from 'styled-components';

import { CheckCircleFullIcon, EmptyCircleIcon } from 'refactored/ui/icons';
import {
  useSoFormStepsApi,
  useSoFormStepsState,
} from 'refactored/features/soForm/SoForm.context';
//

const SoFormCheckboxInputLabel = styled.div`
  height: 24px;

  /* 16px/regular

Shipper App Default
*/
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* grey / 700 */

  color: var(--grey700);

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 1;
`;

const SoFormCheckboxInputIconContainer = styled.div`
  display: flex;
`;

const SoFormCheckboxInput = styled(({ className, inputData }) => {
  // state
  const stepsApi = useSoFormStepsApi();
  const stepsState = useSoFormStepsState();
  const isSelected = stepsState.configuration.extras.includes(
    inputData.extraName
  );

  const toggleExtra = () => {
    if (isSelected) stepsApi.removeExtra(inputData.extraName);
    else stepsApi.addExtra(inputData.extraName);
  };

  return (
    <div className={className} onClick={toggleExtra}>
      <SoFormCheckboxInputLabel>{inputData.label}</SoFormCheckboxInputLabel>
      <SoFormCheckboxInputIconContainer isSelected={isSelected}>
        {isSelected ? <CheckCircleFullIcon /> : <EmptyCircleIcon />}
      </SoFormCheckboxInputIconContainer>
    </div>
  );
})``;

SoFormCheckboxInput.propTypes = {
  className: PropTypes.string,
};

const regularCSS = css`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 12px 12px 16px;
  gap: 12px;
  width: 184px;
  height: 48px;
  background: #ffffff;
  border-width: 1px 1px 1px 4px;
  border-style: solid;
  border-color: #ccd6e0;
  border-radius: 4px;
  flex: none;
  order: 0;
  flex-grow: 1;
  cursor: pointer;
`;

export default styled(SoFormCheckboxInput)`
  ${regularCSS}
`;
